var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side-nav-item",class:{ toggled: _vm.toggled }},[(_vm.notification)?_c('dig-ui-badge',[_vm._v(_vm._s(_vm.notification))]):_vm._e(),_c('router-link',{class:{
      title: _vm.isTitle,
      active: _vm.isActive,
      clickable: _vm.isClickable,
      depth: _vm.isDepth,
    },attrs:{"to":_vm.to}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }